import { Label } from '@/components/ui/label';

type FormFieldLabelProps = {
  htmlFor: string;
  label: string;
  isRequired?: boolean;
  showAsterisk?: boolean;
};

export function FormFieldLabel({ htmlFor, label, showAsterisk }: FormFieldLabelProps) {
  return (
    <Label htmlFor={htmlFor} className="gap-0">
      <span className="inline">
        {label}
        {showAsterisk && (
          <span aria-hidden="true" className="ml-1">
            *
          </span>
        )}
      </span>
    </Label>
  );
}

type FormFieldLegendProps = {
  id?: string;
  label: string;
  showAsterisk?: boolean;
};

export function FormFieldLegend({ id, label, showAsterisk }: FormFieldLegendProps) {
  return (
    <legend id={id} className="text-sm leading-none font-medium select-none">
      <span className="inline">
        {label}
        {showAsterisk && (
          <span aria-hidden="true" className="ml-1">
            *
          </span>
        )}
      </span>
    </legend>
  );
}
